/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_PrivacyInputs */

const en_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const es_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const fr_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const de_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzrichtlinie`)
};

const ja_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

const zh_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私政策`)
};

const ar_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سياسة الخصوصية`)
};

const id_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan Privasi`)
};

const it_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informativa sulla Privacy`)
};

const ru_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

const pt_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Privacidade`)
};

const ko_footer_link_privacy = /** @type {(inputs: Footer_Link_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보 처리방침`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_Link_PrivacyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_privacy = /** @type {((inputs?: Footer_Link_PrivacyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_PrivacyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_privacy(inputs)
	if (locale === "es") return es_footer_link_privacy(inputs)
	if (locale === "fr") return fr_footer_link_privacy(inputs)
	if (locale === "de") return de_footer_link_privacy(inputs)
	if (locale === "ja") return ja_footer_link_privacy(inputs)
	if (locale === "zh") return zh_footer_link_privacy(inputs)
	if (locale === "ar") return ar_footer_link_privacy(inputs)
	if (locale === "id") return id_footer_link_privacy(inputs)
	if (locale === "it") return it_footer_link_privacy(inputs)
	if (locale === "ru") return ru_footer_link_privacy(inputs)
	if (locale === "pt") return pt_footer_link_privacy(inputs)
	return ko_footer_link_privacy(inputs)
});